import * as Yup from "yup";

const user = JSON.parse(sessionStorage.getItem("authUser"));

const workerValidationSchema = Yup.object({      
    name: Yup.string().required("Molimo unesite naziv dijela."),
});
  
const adminValidationSchema = Yup.object({      
    name: Yup.string().required("Molimo unesite naziv dijela."),
    sellingPrice: Yup.number("Molimo unesite prodajnu cijenu dijela").positive("Molimo unesite prodajnu cijenu dijela").required("Molimo unesite prodajnu cijenu dijela")
    
});

const partInitValues = {
    name: "",
    catalogNumber: "",
    location: "",
    position: "",
    originVehicle: "",
    color: "",
    yearStart: -1,
    yearEnd: -1,
    sellingPrice: "",
    description: "",
    status: "",
    category: "",
    attributes: []
};

const partValidationSchema = user && user.role && user.role === "1" ? adminValidationSchema : workerValidationSchema;

export {partInitValues, partValidationSchema};